<template>
  <div class="toast" v-if="showFlag">
    {{text}}
    <div @click="close" class="close">关闭</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFlag: false,
      text: '提示'
    };
  },
  methods: {
    close() {
      this.showFlag = false
    }
  }
};
</script>

<style scoped>
.toast {
  position: fixed;
  z-index: 9999999;
  left: 50%;
  top: 50%;
  transition: all 0.5s;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  -o-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: rgba(17, 17, 17, 0.7);
  min-height: 30px;
  line-height: 30px;
  /* max-width: 150px; */
  font-size: 15px;
  min-width: 200px;
  max-width: 300px;
  padding: 10px 15px;
  opacity: 1;
}
.close {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
}
</style>